<template>
	<div class="w-full">
		<div class="flex flex-row items-end color w-full">
			<vs-input readonly class="w-1/2 rounded-r-none" :label="$t('MODULE.hexaColor')" v-model="questionsByPage[index].properties.color"/>		
			<div class="relative">
				<input class="mr-3 absolute" ref="color"  type="color" v-model="questionsByPage[index].properties.color">
				<vs-button class="rounded-l-none" color="success" type="filled" @click="openColor">Color</vs-button>
			</div>
			<div v-if="!isQR" class="muestra-color ml-3 rounded-full" :style="{background: color}"></div>					
		</div>			
	</div>	
</template>

<script type="text/javascript">
	import { mapState } from 'vuex';
	import VueQr from 'vue-qr';
	export default {
		components:{VueQr},
		props: {
			index: Number,
			isQR: {
				type: Boolean,
				default: false,
				required: false
			}			
		},
		methods: {
			openColor() {
				this.$refs.color.click();
			}
		},
		computed: {
			...mapState('resource',['questionsByPage']),
			color() {
				return this.questionsByPage[this.index].properties.color
			}
		}
	}
</script>

<style type="text/css">
	.color .vs-input--input {
		border-top-right-radius: 0px!important;
		border-bottom-right-radius: 0px!important;		
	}
	.muestra-color {
		width: 40px;
		height: 40px;
	}
</style>